import React from "react";
import { getLpcPreviewStyle } from "./../../../helper/lpcHelper.js";

const RARITY_COLORS = {
  common: '#9E9E9E',
  rare: '#2196F3',
  epic: '#9C27B0',
  legendary: '#FF9800',
  mythic: '#F44336'
};

const RARITY_GRADIENTS = {
  common: 'linear-gradient(135deg, #BDBDBD 0%, #757575 100%)',
  rare: 'linear-gradient(135deg, #64B5F6 0%, #1976D2 100%)',
  epic: 'linear-gradient(135deg, #BA68C8 0%, #6A1B9A 100%)',
  legendary: 'linear-gradient(135deg, #FFB74D 0%, #E65100 100%)',
  mythic: 'linear-gradient(135deg, #EF5350 0%, #B71C1C 100%)'
};

/**
 * PixelInventoryItem — card de item LPC pixel art com preview do sprite.
 */
class PixelInventoryItem extends React.Component {
  formatHint(hint) {
    if (!hint || !hint.length) return null;
    var labels = { badge: 'Badge', certificate: 'Certificado', level: 'Nível', streak: 'Streak', mission: 'Missão' };
    return hint.map(function (h) {
      var label = labels[h.type] || h.type;
      if (h.value === 'any') return label;
      if (h.type === 'level') return label + ' ' + h.value;
      if (h.type === 'streak') return h.value + ' dias';
      return label + ': ' + h.value;
    }).join(' · ');
  }

  render() {
    var item = this.props.item;
    var rarity = item.rarity || 'common';
    var color = RARITY_COLORS[rarity];
    var gradient = RARITY_GRADIENTS[rarity];
    var equipped = item.equipped === 1 || item.equipped === true;
    var owned = item.owned === undefined ? true : item.owned;
    var locked = !owned;

    return (
      <div
        onClick={() => this.props.onClick && this.props.onClick(item)}
        style={{
          cursor: 'pointer',
          borderRadius: '10px',
          padding: '8px',
          background: equipped ? gradient : (locked ? '#f5f5f5' : '#fff'),
          border: equipped ? '3px solid #FFD700' : (locked ? '2px dashed #bbb' : '2px solid ' + color + '40'),
          boxShadow: equipped
            ? '0 4px 16px ' + color + '60'
            : '0 2px 6px rgba(0,0,0,0.05)',
          transition: 'all 0.2s',
          textAlign: 'center',
          position: 'relative',
          minHeight: '200px',
          opacity: locked ? 0.65 : 1,
          filter: locked ? 'grayscale(0.6)' : 'none'
        }}
        onMouseEnter={(e) => { if (!equipped && !locked) e.currentTarget.style.transform = 'scale(1.05)'; }}
        onMouseLeave={(e) => { e.currentTarget.style.transform = 'scale(1)'; }}
      >
        {equipped && (
          <div style={{
            position: 'absolute',
            top: '6px',
            right: '6px',
            background: '#FFD700',
            color: '#fff',
            borderRadius: '12px',
            padding: '2px 8px',
            fontSize: '0.65rem',
            fontWeight: 700,
            zIndex: 2
          }}>
            <i className="fas fa-check mr-1" />ATIVO
          </div>
        )}
        {locked && (
          <div style={{
            position: 'absolute',
            top: '6px',
            right: '6px',
            background: '#666',
            color: '#fff',
            borderRadius: '12px',
            padding: '2px 8px',
            fontSize: '0.65rem',
            fontWeight: 700,
            zIndex: 2
          }}>
            <i className="fas fa-lock mr-1" />BLOQUEADO
          </div>
        )}
        {this.props.aiBadge && (
          <div style={{
            position: 'absolute',
            top: '6px',
            left: '6px',
            background: 'linear-gradient(135deg, #7B1FA2 0%, #E91E63 100%)',
            color: '#fff',
            borderRadius: '12px',
            padding: '2px 8px',
            fontSize: '0.6rem',
            fontWeight: 700,
            zIndex: 2
          }}>
            IA ✨
          </div>
        )}

        {/* Preview do sprite */}
        <div style={{
          width: '90px',
          height: '90px',
          margin: '0 auto',
          background: 'linear-gradient(180deg, #b3d9ff 0%, #87ceeb 100%)',
          borderRadius: '8px',
          border: '2px solid ' + color,
          overflow: 'hidden',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
          {item.lpcLayer ? (
            <div style={{
              width: '80px',
              height: '80px',
              overflow: 'hidden',
              position: 'relative',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
              <div style={getLpcPreviewStyle(item.lpcLayer, 80, item.slot)} />
            </div>
          ) : (
            <i className="fas fa-question text-muted" style={{ fontSize: '2rem' }} />
          )}
        </div>

        <div className="mt-2">
          <div style={{
            fontSize: '0.8rem',
            fontWeight: 700,
            color: equipped ? '#fff' : '#333',
            textShadow: equipped ? '0 1px 2px rgba(0,0,0,0.3)' : 'none'
          }}>
            {item.name}
          </div>
          <div style={{
            fontSize: '0.65rem',
            color: equipped ? 'rgba(255,255,255,0.9)' : color,
            textTransform: 'uppercase',
            fontWeight: 600,
            marginTop: '2px',
            letterSpacing: '0.5px'
          }}>
            <i className={'fas fa-' + (rarity === 'legendary' ? 'star' : rarity === 'mythic' ? 'crown' : 'gem') + ' mr-1'} />
            {rarity}
          </div>
          {/* Atributos: a peca deixou de ser so enfeite */}
          {(item.bonusHp > 0 || item.bonusDamage > 0) && (
            <div style={{ fontSize: '0.65rem', marginTop: '3px', fontWeight: 700 }}>
              {item.bonusHp > 0 && (
                <span style={{ color: equipped ? '#fff' : '#28a745', marginRight: '6px' }}>
                  <i className="fas fa-heart mr-1" />+{item.bonusHp}
                </span>
              )}
              {item.bonusDamage > 0 && (
                <span style={{ color: equipped ? '#fff' : '#dc3545' }}>
                  <i className="fas fa-fist-raised mr-1" />+{item.bonusDamage}
                </span>
              )}
            </div>
          )}
          {locked && item.unlockHint && item.unlockHint.length > 0 && (
            <div style={{
              fontSize: '0.6rem',
              color: '#888',
              marginTop: '4px',
              fontStyle: 'italic',
              borderTop: '1px solid #ddd',
              paddingTop: '4px'
            }}>
              <i className="fas fa-key mr-1" />
              {this.formatHint(item.unlockHint)}
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default PixelInventoryItem;
